export default {
  chartTitle: 'SECTOR MATCH VALUE PROPORTION',
  tooltip: {
    contribution: 'Contribution',
  },
  valueProprotion: 'Value Proportion (%)',
  footer:
    ' Each sectors include all tickers from HOSE, HNX and UPCOM. (Sector value proportion is calculated base on total match value.)',
  listFrequencyByKey: {
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
  },
  rightLabel: 'Value Contribution (%)',
  listTitleTable: {
    ICB_NAME: 'SECTOR',
    MARKET_CAP: 'Market Cap',
    PERCENT_PRICE_CHANGE_1DAY: '% 1 Day',
    PERCENT_PRICE_CHANGE_1WEEK: '% 1 Week',
    PERCENT_PRICE_CHANGE_2WEEK: '% 2 Weeks',
    PERCENT_PRICE_CHANGE_1MONTH: '% 1 Month',
    PERCENT_PRICE_CHANGE_3MONTH: '% 3 Months',
    PERCENT_PRICE_CHANGE_6MONTH: '% 6 Months',
    PERCENT_PRICE_CHANGE_9MONTH: '% 9 Months',
    PERCENT_PRICE_CHANGE_1YEAR: '% 1 Year',
    PERCENT_PRICE_CHANGE_YTD: '% YTD',
    AVERAGE_MATCHED_VOLUME_1WEEK: 'Avg Vol. 1W',
    AVERAGE_MATCHED_VOLUME_2WEEK: 'Avg Vol. 2W',
    AVERAGE_MATCHED_VOLUME_1MONTH: 'Avg Vol. 1M',
    AVERAGE_MATCHED_VOLUME_3MONTH: 'Avg Vol. 3M',
  },
  tab: {
    _3_months: '3M',
    _6_months: '6M',
    _9_months: '9M',
    this_year: '1Y',
    three_years: '3Y',
    five_years: '5Y',
  },
};
